import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";

//Redux
import { useSelector, useDispatch } from "react-redux";

//API
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import { InputField } from "../../../../Components/formElements/InputField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import Constants from "../../../../common/SupplierConstants";
import { currencyFormat, getCurrentDate } from "../../../../common/Validations";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import HeaderText from "../../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
import { getInvoiceList } from "../../../../redux/feature/supplier_app/purchasingSlice";
const CreateInvoice = () => {
  const dispatch = useDispatch();

  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Purchase Order");

  let selectedPoDetails = useSelector(
    (state) => state?.purchasing?.purchase_order?.selectedPoDetails,
  ); // selectedPoDetails Details from Store

  let poNumber = useSelector(
    (state) => state?.purchasing?.purchase_order?.poNumber,
  ); // purchase_order from Store

  let userData = useSelector((state) => state?.user.data); // User Details from Store

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  // invoice columns
  const invoiceDataColumns = [
    {
      name: "Invoice Item Nr",
      selector: (row) => row.invoiceItemNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "120px",
    },
    {
      name: "GRN Item Nr",
      selector: (row) => row.grnItemNr,
      sortable: true,
      width: "130px",
    },
    {
      name: "GRN Nr",
      selector: (row) => row.grnNr,
      sortable: true,
      width: "130px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-info-status">{"New"}</span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row.materialCode} </p>
            <p className="m-0 p-0">{row.materialDescription} </p>
          </div>
        </>
      ),
      width: "180px",
      sortable: true,
    },
    {
      name: "Purchase Qty",
      selector: (row) => row.purchaseQuantity,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="purchaseQuantity"
            value={row.purchaseQuantity}
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "GRN Qty",
      selector: (row) => row.grnQuantity,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="grnQuantity"
            value={row.grnQuantity}
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Invoice Qty",
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="invoiceQuantity"
            name="invoiceQuantity"
            value={row.invoiceQuantity}
            onChange={(e) =>
              handleInputChangeTable(
                row.local_id,
                e.target.value,
                row.grnQuantity,
                row.orderPriceUnit,
                row.invBalancePurchaseQuantity,
                row.originalBalancePurchaseQuantity,
              )
            }
            disabled={row.originalBalancePurchaseQuantity === 0 ? true : false}
          />
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Invoice Balance Qty",
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="invBalancePurchaseQuantity"
            value={Number(row?.invBalancePurchaseQuantity) || 0}
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Oder Unit",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      name: "Unit Price",
      // selector: (row) => row.orderPriceUnit,
      cell: (row) => (
        <span className="numberFormate">
          {currencyFormat(Number(row.orderPriceUnit).toFixed(2))}
        </span>
      ),

      sortable: true,
      width: "120px",
    },
    {
      name: "Item Value",
      selector: (row) => row.totalPrice,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="totalPrice"
            value={row.totalPrice || 0}
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Inv Item TAX",
      selector: (row) => row.invItemTaxValue,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="invItemTaxValue"
            value={
              Number(Number(row.taxCode / 100) * Number(row.invoiceQuantity)) ||
              0
            }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Tax Code",
      selector: (row) => row.taxCode,
      sortable: true,
      width: "130px",
    },
    {
      name: "Total Value",
      selector: (row) => row.netValue,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="netValue"
            value={row.netValue || 0}
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode,
      sortable: true,
      width: "120px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Desc",
      selector: (row) => row.taxIdDesc,
      sortable: true,
      width: "200px",
    },
    {
      name: "PReq Nr",
      selector: (row) => row.purchaseReqNr,
      sortable: true,
      width: "200px",
    },
    {
      name: "PReq Item Nr ",
      selector: (row) => row.purchaseReqitemNr,
      sortable: true,
      width: "200px",
    },
    {
      name: "ExcessTolerance",
      selector: (row) => row.excessTolerance,
      sortable: true,
      width: "200px",
    },
    {
      name: "ShortageTolerance",
      selector: (row) => row.shortageTolerance,
      sortable: true,
      width: "200px",
    },
  ];

  const modalData = {
    title: "Invoice Creation",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [disabled, setDisabled] = useState(false);

  // const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  // eslint-disable-next-line
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);

  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [getDisabledStatus, setDisabledStatus] = useState(true);
  const [getHeaderData, setHeaderData] = useState(false);
  const [itemTableData, setItemTableData] = useState([]);
  const [getCreateInvoiceData, setCreateInvoiceData] = useState([]);

  const [getInvoiceValue, setInvoiceValue] = useState(0);
  const [currentDate] = useState(getCurrentDate("default"));
  const [subTotalValue, setSubTotalValue] = useState(0);
  const [getInvTaxTotalValue, setInvTaxTotalValue] = useState(0);
  const [getOtherChargesValue, setOtherChargesValue] = useState(0);

  const [formInputs, setFormInputs] = useState({
    transactionActivity: "INV",
    subTransactionActivity: "GRN",
    vendorCode: "",
    purchasingDocumentNr: "",
    purchasingDocumentDate: "",
    purchasingDocumentValue: "",
    currency: "",
    currencyCode: "",
    paymentTerms: "",
    totalInvoiceAmount: "",
    sumOfCurrentAmt: "",
    notes: "",
    weighSlipQty: "",
    itemClass: "",
    vendorInvoiceNo: "",
    vendorInvoiceDate: "",
    vendorInvoiceCurrency: "",
    vendorBasicValue: "",
    vendorFreightValue: "",
    vendorTaxValue: "",
    vendorOtherChargesValue: "",
    vendorTotalInvoiceValue: "",
    invoicedValue: "",
    generatedBy: "",
    createdBy: "",
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible4);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible4);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
  };

  // Function to handle text changes
  const handleInputChangeTable = (
    id,
    value,
    grnQuantity,
    orderPriceUnit,
    invBalancePurchaseQuantity,
    originalBalancePurchaseQuantity,
  ) => {
    if (Number(originalBalancePurchaseQuantity) >= Number(value)) {
      let totalPriceVal = Number(orderPriceUnit) * Number(value);
      setInvoiceValue(totalPriceVal);

      const updatedData = itemTableData.map((item) => {
        return item.local_id === id
          ? {
              ...item,
              invoiceQuantity: Number(value),
              invBalancePurchaseQuantity: (
                Number(originalBalancePurchaseQuantity) - Number(value)
              ).toFixed(2),
              totalPrice: totalPriceVal,
              invItemTaxValue: Number(
                Number(item.taxCode / 100) * Number(value),
              ),
            }
          : item;
      });

      const filteredData = updatedData.filter(
        (item) =>
          item.hasOwnProperty("invoiceQuantity") && item.invoiceQuantity !== 0,
      );

      setItemTableData(updatedData);
      setCreateInvoiceData(filteredData);
      getTotalCount(updatedData);
    } else {
      // console.log("Do Nothing");
    }
  };

  // Get Total for SubTotal Pricing Schedule
  const getTotalCount = (data) => {
    const getTotal = data.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.totalPrice || 0),
      0,
    );
    setSubTotalValue(getTotal);
    setInvoiceValue(getTotal);

    let invTotalTaxVa = 0;
    data.map((item) => {
      return (invTotalTaxVa +=
        (Number(item.taxCode) / 100) * Number(item.invoiceQuantity || 0));
    });
    setInvTaxTotalValue(Number(invTotalTaxVa));
  };

  // load invoice data on page load
  const loadInitalPageData = async () => {
    setLoading(true);
    if (poNumber) {
      setHeaderData(selectedPoDetails);

      let obj = {
        purchasingDocumentNr: poNumber,
      };

      await ItemService.createInvoice(obj).then(async (item) => {
        // console.log(">> res! createInvoice", item);
        if (item?.status === 200) {
          const rawRows = item?.data || [];

          // The createInvoice rows carry only a subset of fields. The full PO
          // line items (selectedPoDetails.items) hold the pricing / tax /
          // tolerance keys the invoice table renders (orderPriceUnit, taxCode,
          // netValue, deliveryDate, taxAmount, taxIdDesc, purchaseReqNr,
          // purchaseReqitemNr, excessTolerance, shortageTolerance, ...), so
          // build a lookup keyed by PO item number and material code. If the
          // PO is not in the store (e.g. direct page load), fetch it.
          let poItems = selectedPoDetails?.items || [];
          if (!poItems.length && poNumber) {
            try {
              const poRes = await ItemService.getPurchaseOrderDetail({
                documentNumber: poNumber,
              });
              if (poRes?.status === 200) poItems = poRes?.data?.items || [];
            } catch (err) {
              console.error("Failed to load PO detail:", poNumber, err);
            }
          }
          const poItemByLine = {};
          const poItemByMaterial = {};
          (poItems || []).forEach((poItem) => {
            const line = String(
              poItem?.purchasingDocumentItemNr ??
                poItem?.lineNo ??
                poItem?.lineItemNumber ??
                poItem?.itemNumber ??
                "",
            ).trim();
            if (line) poItemByLine[line] = poItem;
            const mat = String(
              poItem?.materialCode ??
                poItem?.itemCode ??
                poItem?.productCode ??
                poItem?.partNumber ??
                poItem?.materialNumber ??
                "",
            ).trim();
            if (mat) poItemByMaterial[mat] = poItem;
          });

          // Also load the related GRN detail(s) - the same call the GRN
          // details page makes (getGrnDatail) - and map their line items so
          // any GRN-specific stored fields are present on the invoice rows.
          let grnInvoiceDocument = "";
          let grnHeader = null;
          const grnItemByLine = {};
          const grnItemByMaterial = {};
          const grnNrs = [
            ...new Set((rawRows || []).map((r) => r?.grnNr).filter(Boolean)),
          ];
          await Promise.all(
            grnNrs.map(async (grnNr) => {
              try {
                const grnRes = await ItemService.getGrnDatail({
                  documentNumber: grnNr,
                  timeZone: "Asia/Calcutta",
                });
                if (grnRes?.status === 200 && grnRes?.data?.[0]) {
                  grnHeader = grnRes?.data?.[0];
                  grnInvoiceDocument =
                    grnHeader?.invoiceBillDocument ||
                    grnHeader?.attachmentId ||
                    grnInvoiceDocument;
                }
                const grnItems =
                  grnRes?.status === 200 ? grnRes?.data?.[0]?.items : [];
                (grnItems || []).forEach((grnItem) => {
                  const line = String(
                    grnItem?.purchasingDocumentItemNr ??
                      grnItem?.lineNo ??
                      grnItem?.lineItemNumber ??
                      grnItem?.itemNumber ??
                      "",
                  ).trim();
                  if (line) grnItemByLine[line] = grnItem;
                  const mat = String(
                    grnItem?.materialCode ??
                      grnItem?.itemCode ??
                      grnItem?.productCode ??
                      grnItem?.partNumber ??
                      grnItem?.materialNumber ??
                      "",
                  ).trim();
                  if (mat) grnItemByMaterial[mat] = grnItem;
                });
              } catch (err) {
                console.error("Failed to load GRN detail:", grnNr, err);
              }
            }),
          );

          // Merge order: GRN detail -> PO line item -> the createInvoice row
          // itself wins, so keys the API already provides (grnNr,
          // invBalancePurchaseQuantity, grnQuantity, ...) are never overridden
          // by the enrichment data.
          const updatedItemData = rawRows.map((row, index) => {
            const lineKey = String(
              row?.purchasingDocumentItemNr ??
                row?.lineNo ??
                row?.lineItemNumber ??
                row?.itemNumber ??
                "",
            ).trim();
            const matKey = String(
              row?.materialCode ??
                row?.itemCode ??
                row?.productCode ??
                row?.partNumber ??
                row?.materialNumber ??
                "",
            ).trim();
            const poItem =
              poItemByLine[lineKey] || poItemByMaterial[matKey] || {};
            const grnItem =
              grnItemByLine[lineKey] || grnItemByMaterial[matKey] || {};

            const merged = {
              ...grnItem,
              ...poItem,
              ...row,
              invoiceItemNr: index + 1,
              local_id: index + 1,
              originalBalancePurchaseQuantity: row.invBalancePurchaseQuantity,
            };

            // Auto-fill the invoice quantity with the remaining GRN balance so
            // the line is ready to bill, and derive the price / tax figures the
            // UI renders from the merged order price unit + tax code. OCR/GRN
            // lines may store the unit price as unitPrice/rate instead of the
            // PO-style orderPriceUnit, so fall back through those.
            const originalBalance = Number(
              merged.invBalancePurchaseQuantity ?? 0,
            );
            const invoiceQuantity = Number(
              merged.invoiceQuantity ?? originalBalance ?? 0,
            );
            const orderPriceUnit = Number(
              merged.orderPriceUnit ?? merged.unitPrice ?? merged.rate ?? 0,
            );
            const taxCode = Number(
              merged.taxCode ?? merged.taxPercent ?? merged.taxRate ?? 0,
            );
            const totalPrice = orderPriceUnit * invoiceQuantity;

            return {
              ...merged,
              invoiceQuantity,
              totalPrice,
              netValue: totalPrice || Number(merged.netValue || 0) || 0,
              orderPriceUnit,
              taxCode,
              invBalancePurchaseQuantity: (
                originalBalance - invoiceQuantity
              ).toFixed(2),
              invItemTaxValue: (taxCode / 100) * invoiceQuantity,
            };
          });

          setItemTableData(updatedItemData);

          // Keep the invoice rows that carry a quantity ready to submit.
          const filteredData = updatedItemData.filter(
            (row) => Number(row.invoiceQuantity || 0) !== 0,
          );
          setCreateInvoiceData(filteredData);
          getTotalCount(updatedItemData);

          // Auto-fill the Invoice Header / details fields from the loaded data.
          const totalWeighSlipQty = updatedItemData.reduce(
            (acc, row) => acc + Number(row.grnQuantity || 0),
            0,
          );
          setFormInputs((prev) => ({
            ...prev,
            weighSlipQty: totalWeighSlipQty || prev.weighSlipQty,
            // type="date" input needs YYYY-MM-DD (getCurrentDate("default") is DD-MM-YYYY)
            vendorInvoiceDate:
              getCurrentDate("short") || prev.vendorInvoiceDate,
            invoiceBillDocument:
              grnInvoiceDocument || prev.invoiceBillDocument || "",
          }));
          setOtherChargesValue(
            Number(
              selectedPoDetails?.purchasingDocumentOtherChargesValue ??
                selectedPoDetails?.qtnSubTotalOtherCharges ??
                0,
            ) || 0,
          );

          // If the GRN header stored header-level invoice figures, let those
          // win over the derived / PO values so the UI reflects exactly what
          // was created at GRN time (invoiceValue, subTotalValue,
          // getInvTaxTotalValue, getOtherChargesValue, vendorInvoiceNo,
          // vendorBasicValue, vendorTaxValue, vendorOtherChargesValue,
          // vendorFreightValue, vendorTotalInvoiceValue).
          if (grnHeader) {
            setSubTotalValue((prev) =>
              grnHeader?.subTotalValue != null
                ? Number(grnHeader.subTotalValue)
                : prev,
            );
            setInvoiceValue((prev) =>
              grnHeader?.invoiceValue != null
                ? Number(grnHeader.invoiceValue)
                : grnHeader?.subTotalValue != null
                  ? Number(grnHeader.subTotalValue)
                  : prev,
            );
            setInvTaxTotalValue((prev) =>
              grnHeader?.getInvTaxTotalValue != null
                ? Number(grnHeader.getInvTaxTotalValue)
                : grnHeader?.vendorTaxValue != null
                  ? Number(grnHeader.vendorTaxValue)
                  : prev,
            );
            setOtherChargesValue((prev) =>
              grnHeader?.getOtherChargesValue != null
                ? Number(grnHeader.getOtherChargesValue)
                : grnHeader?.vendorOtherChargesValue != null
                  ? Number(grnHeader.vendorOtherChargesValue)
                  : prev,
            );
            setFormInputs((prev) => ({
              ...prev,
              vendorInvoiceNo:
                grnHeader?.vendorInvoiceNo || prev.vendorInvoiceNo,
              vendorBasicValue:
                grnHeader?.vendorBasicValue != null
                  ? Number(grnHeader.vendorBasicValue)
                  : prev.vendorBasicValue,
              vendorTaxValue:
                grnHeader?.vendorTaxValue != null
                  ? Number(grnHeader.vendorTaxValue)
                  : prev.vendorTaxValue,
              vendorOtherChargesValue:
                grnHeader?.vendorOtherChargesValue != null
                  ? Number(grnHeader.vendorOtherChargesValue)
                  : prev.vendorOtherChargesValue,
              vendorFreightValue:
                grnHeader?.vendorFreightValue != null
                  ? Number(grnHeader.vendorFreightValue)
                  : prev.vendorFreightValue,
              vendorTotalInvoiceValue:
                grnHeader?.vendorTotalInvoiceValue != null
                  ? Number(grnHeader.vendorTotalInvoiceValue)
                  : prev.vendorTotalInvoiceValue,
            }));
          }
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
      });

      setLoading(false);
    } else {
      window.history.back();
    }
  };

  // load SupplierBank data on page load
  const loadSupplierBank = async () => {
    if (poNumber) {
      let obj = {
        userId: userData?.userId,
      };

      await ItemService.getSupplierBank(obj).then((item) => {
        // console.log(">> res! getSupplierBank", item);
        if (item?.status === 200) {
          // setSupplierBankData(item.data);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
      });
    } else {
      window.history.back();
    }
  };

  useEffect(() => {
    loadInitalPageData();
    loadSupplierBank(); // load bank
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poNumber, selectedPoDetails]);

  // const [getHeaderTextIndex, setHeaderTextIndex] = useState(0);
  const [HeaderTextModel, setHeaderTextModel] = useState(false);

  /* Header text selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);
  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
  };

  useEffect(() => {
    // Only recompute Other Charges from header text when rows are actually
    // selected — otherwise it resets auto-filled PO other-charges to 0 on mount.
    if (!getHeaderTextSelectedData?.length) return;
    const getTotal = getHeaderTextSelectedData.reduce(
      (accumulator, currentValue) =>
        accumulator + Number(currentValue?.documentText || 0),
      0,
    );
    setOtherChargesValue(getTotal);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getHeaderTextSelectedData]);

  /* Create Header Text Modal Function */
  const showsetHeaderText = () => {
    setHeaderTextModel(true);
  };
  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };
  // For Upload Success
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const HeaderTextColumns = [
    {
      name: "Code",
      cell: (row) => (
        <>
          <span>{row.documentId}</span>
        </>
      ),
      width: "30rem",
    },
    {
      name: "Value",
      cell: (row) => (
        <>
          <span>{row.documentText}</span>
        </>
      ),
      width: "30rem",
    },
    // {
    //   name: "Delete",
    //   cell: (row, index) => (
    //     <>
    //       <span>
    //         <i
    //           onClick={() => handleDelete(index)}
    //           className="bi bi-trash text-danger fs-3"
    //         ></i>
    //       </span>
    //     </>
    //   ),
    //   width: "10rem",
    // },
  ];

  // SAVE
  const handleSave = async () => {
    // let requiredFields = [];

    // if(!validateRequired(formInputs?.organisationName)) {
    //   requiredFields.push('*Please enter Supplier Name');
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    // if (!validateEmail(formInputs?.email)) {
    //   requiredFields.push('*Invalid Contact Email address');
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    // if (!getPOLineItemsData[0]?.materialCode) {
    //   toast.error("Alteast one PO Line item should be added.", {
    //     duration: 4000,
    //     position: "top-right",
    //   });
    //   return;
    // }

    formInputs.items = getCreateInvoiceData;
    formInputs.vendorCode = getHeaderData.vendorCode;
    formInputs.vendorName = getHeaderData.vendorName;
    formInputs.vendorInvoiceDate = currentDate;
    formInputs.deliveredValue = getHeaderData.deliveredValue;
    formInputs.deliveredStatus = getHeaderData.deliveredStatus;
    formInputs.invoicedValue = getHeaderData.invoicedValue;
    formInputs.invoicedStatus = getHeaderData.invoicedStatus;
    formInputs.paidValue = getHeaderData.paidValue;
    formInputs.vendorInvoiceCurrency = getHeaderData.currencyCode;
    formInputs.currency = getHeaderData.currencyCode;
    formInputs.purchasingDocumentDate = getHeaderData.purchasingDocumentDate;
    formInputs.incoTerms = getHeaderData.incoTerms;
    formInputs.paymentTerms = getHeaderData.paymentTerms;
    formInputs.purchasingDocumentNr = getHeaderData.purchasingDocumentNr;
    formInputs.purchasingDocumentValue = getHeaderData.purchasingDocumentValue;
    formInputs.currency = getHeaderData.currency;
    formInputs.currencyCode = getHeaderData.currencyCode;
    formInputs.vendorOtherChargesValue = Number(
      getOtherChargesValue.toFixed(2),
    );
    formInputs.vendorTotalInvoiceValue = Number(
      (
        Number(subTotalValue) +
        Number(getOtherChargesValue) +
        Number(getInvTaxTotalValue) +
        Number(formInputs.vendorFreightValue)
      ).toFixed(2),
    );
    formInputs.vendorBasicValue = Number(subTotalValue.toFixed(2));
    formInputs.vendorTaxValue = Number(getInvTaxTotalValue);

    // console.log(">> handleSave", formInputs);

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let obj = {
      data: formInputs,
    };

    // console.log(">>obj",obj)

    setDisabled(true);
    await ItemService.addInvoice(obj).then((item) => {
      console.log(">> res!", item);
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();

        // Update response value in Redux Store
        dispatch(getInvoiceList());
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  // const handleFileChange = (event) => {
  //   // const selectedFile = event.target.files[0];
  //   setFile(event.target.files[0]);
  // };

  // const selectFile = () => {
  //   fileInputRef.current.click();
  // };
  // const cancelInvoice = () => {
  //   setFile(null);
  // };

  // const uploadInvoice = async () => {
  //   setUploadStatus(true);
  //   if (file) {
  //     // Create FormData and append the file
  //     const formData = new FormData();
  //     formData.append("file", file);

  //     await ItemService.uploadOCRFile(formData).then((item) => {
  //       // console.log(">> uploadOCRFile data ", item);
  //       setInvoiceData(item?.data);
  //       setFile(null);
  //       // if (item?.status === 200) {
  //       //   setInvoiceData(item?.data);
  //       // } else {
  //       //   setInvoiceData([]);
  //       //   console.log(">> Error: Loading getSupplierDatail");
  //       // }
  //     });
  //     setUploadStatus(false);
  //   } else {
  //     // alert('Please select a file first.');
  //   }
  // };

  return (
    <main className="dashboard main" id="main">
      <Layout />

      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Create-Invoice for
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {getHeaderData?.purchasingDocumentNr}
              </span>
              <span>
                {getHeaderData?.statusHeader === "New" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "In Release" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "Acknowledged" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : (
                  getHeaderData?.statusHeader
                )}
              </span>
            </h2>
            <p className="subText">Fill Invoice Details</p>
            <hr />

            {itemTableData.length === 0 && (
              <>
                <h1>
                  GRN not available for this PO -{" "}
                  {getHeaderData?.purchasingDocumentNr}
                </h1>
              </>
            )}

            {itemTableData.length > 0 && (
              <>
                {/* Invoice header */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">GH</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Invoice Header</span>
                          <span className="subHeaderTitle">Invoice Header</span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col> */}
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Invoice Date"
                              name="vendorInvoiceDate"
                              placeholder=""
                              value={currentDate}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Invoice Value"
                              name="invoiceValue"
                              placeholder=""
                              value={getInvoiceValue}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Weigh Slip Qty"
                              name="weighSlipQty"
                              placeholder=""
                              value={formInputs.weighSlipQty}
                              onChange={onInputChange}
                              disabled={false}
                            />
                          </Col>
                          {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Invoice No "
                          name=""
                          placeholder=""
                          // value={""}
                          onChange={onInputChange}
                          disabled={false}
                        />
                      </Col> */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="Currency"
                              name="currency"
                              placeholder=""
                              value={`${getHeaderData?.currencyCode} - ${getHeaderData?.currency}`}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Invoice"
                              name=""
                              type="file"
                              placeholder=""
                              // value={""}
                              onChange={onInputChange}
                              disabled={false}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commLeftRightPadding"
                          >
                            <FileUploadComponent
                              id="invoiceBillDocument"
                              name="invoiceBillDocument"
                              label="Invoice"
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={true} // Change to false for single file selection
                              required={true}
                              onSuccessUpload={onSuccessUploadDocumentType}
                              value={formInputs?.invoiceBillDocument || ""}
                              disabled={false}
                            />
                          </Col>
                          <Col>
                            {(formInputs.invoiceBillDocument && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(
                                    formInputs?.invoiceBillDocument,
                                  )
                                }
                              />
                            )) ||
                              "--"}
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="PO Number"
                              name="purchasingDocumentNr"
                              placeholder=""
                              value={getHeaderData.purchasingDocumentNr}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="PO Value"
                              name="purchasingDocumentValue"
                              placeholder=""
                              value={getHeaderData.purchasingDocumentValue}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          {/* <Col
                            xs={8}
                            md={3}
                            lg={3}
                            className="commLeftRightPadding"
                          >
                            <FileUploadComponent
                              id="supportingDocument"
                              name="supportingDocument"
                              label="Invoice"
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={true} // Change to false for single file selection
                              required={true}
                              onSuccessUpload={onSuccessUploadDocumentType}
                              value={formInputs?.supportingDocument || ""}
                              disabled={getDisabledStatus}
                            />
                          </Col> */}
                        {/*   <Col>
                            {(formInputs?.supportingDocument && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.supportingDocument)
                                }
                              />
                            )) ||
                              "--"}
                          </Col> */}
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="Supporting Document"
                              name=""
                              type="file"
                              placeholder=""
                              // value={""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="Vendor"
                              name="vendorCode"
                              placeholder=""
                              value={getHeaderData.vendorCode}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="Vendor Name"
                              name="vendorName"
                              placeholder=""
                              value={getHeaderData.vendorName}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="Tax Amount"
                              name=""
                              placeholder=""
                              value={Number(getInvTaxTotalValue)}
                              // onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="Vendor Name"
                              name="vendorName"
                              placeholder=""
                              value={getHeaderData.vendorName}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Notes "
                              name=""
                              placeholder=""
                              // value={""}
                              onChange={onInputChange}
                              disabled={false}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* invoice service itme details table*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible2
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility2}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PI</span>
                        </Col>
                        <Col xs={12} md={6} lg={6}>
                          <span className="headerTitle">
                            Invoice Service Item Details
                          </span>
                          <span className="subHeaderTitle">
                            Invoice Service Item Details
                          </span>
                        </Col>
                        <Col xs={4} md={2} lg={2} className="">
                          <button className="btnTable">
                            <i className="bi bi-file-excel"></i>Template
                          </button>
                        </Col>
                        <Col xs={4} md={2} lg={2} className="">
                          <button
                            className="btnTable"
                            onClick={() => {
                              alert("asd");
                            }}
                          >
                            <i className="bi bi-file-excel"></i> Upload
                          </button>
                        </Col>
                        <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col>
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible2 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              // title=""
                              columns={invoiceDataColumns}
                              data={itemTableData}
                              progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* other changes table */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible5
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility5}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">OC</span>
                        </Col>

                        <Col xs={5} md={9} lg={9}>
                          <span className="headerTitle">Other Charges</span>
                          <span className="subHeaderTitle">
                            Other Charges Table{" "}
                          </span>
                        </Col>
                        <Col
                          xs={12}
                          md={8}
                          lg={8}
                          className="headerButtonAlign"
                        >
                          <Col xs={4} md={4} lg={4} className="">
                            <button
                              className="btnTable"
                              onClick={showsetHeaderText}
                            >
                              <i className="bi bi-plus-lg"></i>
                            </button>
                          </Col>
                          {/* <Col xs={1} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible5 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              // title=""
                              columns={HeaderTextColumns}
                              data={getHeaderTextSelectedData}
                              // progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Pricing Summary */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible6
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility6}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PS</span>
                        </Col>
                        <Col xs={8} md={4} lg={4}>
                          <span className="headerTitle">Pricing Summary</span>
                          <span className="subHeaderTitle">
                            Pricing Summary{" "}
                          </span>
                        </Col>
                        <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible6 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body p-2">
                        <Row className=" ms-3 ">
                          <Col
                            xs={8}
                            md={4}
                            lg={4}
                            className="d-flex my-2 jsutify-content-center align-items-center"
                          >
                            <p className="fw-medium">
                              SubTotal Pricing Schedule / Line Items
                            </p>
                          </Col>
                          <Col
                            xs={4}
                            md={6}
                            lg={6}
                            className="d-flex my-2 jsutify-content-center align-items-center"
                          >
                            <InputField
                              className="inputBox"
                              name="subTotalValue"
                              placeholder=""
                              value={subTotalValue}
                              disabled={true}
                            />
                            {/* <p className="ms-4 fw-medium"> AED</p> */}
                          </Col>
                          <Col
                            xs={8}
                            md={4}
                            lg={4}
                            className="d-flex my-2 jsutify-content-center align-items-center "
                          >
                            <p className="fw-medium"> SubTotal Other Charges</p>
                          </Col>
                          <Col
                            xs={4}
                            md={7}
                            lg={7}
                            className="d-flex my-2 jsutify-content-center align-items-center "
                          >
                            <InputField
                              className="inputBox"
                              name="getOtherChargesValue"
                              placeholder=""
                              value={getOtherChargesValue}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={8}
                            md={4}
                            lg={4}
                            className="d-flex my-2 jsutify-content-center align-items-center"
                          >
                            <p className="fw-medium">Gross Total</p>
                          </Col>
                          <Col
                            xs={4}
                            md={7}
                            lg={7}
                            className="d-flex jsutify-content-center align-items-center"
                          >
                            <InputField
                              className="inputBox"
                              name="grossTotalValue"
                              placeholder=""
                              value={subTotalValue + getOtherChargesValue}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* invoice details */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible2
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility2}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">ID</span>
                        </Col>

                        <Col xs={4} md={4} lg={4}>
                          <span className="headerTitle"> Invoice details</span>
                          <span className="subHeaderTitle">
                            Invoice details
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible2 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <div className="accordion-body">
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Invoice Number *"
                                    name="vendorInvoiceNo"
                                    id="vendorInvoiceNo"
                                    value={formInputs.vendorInvoiceNo}
                                    onChange={onInputChange}
                                    disabled={false}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Invoice Date*"
                                    name="vendorInvoiceDate"
                                    id="vendorInvoiceDate"
                                    type="date"
                                    value={formInputs.vendorInvoiceDate}
                                    onChange={onInputChange}
                                    disabled={false}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Basic Value *"
                                    name="vendorBasicValue"
                                    placeholder="0.00"
                                    id="vendorBasicValue"
                                    value={subTotalValue.toFixed(2)}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Tax Amount"
                                    name="vendorTaxValue"
                                    placeholder="0.00"
                                    id="vendorTaxValue"
                                    value={Number(getInvTaxTotalValue)}
                                    // onChange={onInputChange}
                                    disabled={true}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Other Charges"
                                    name="vendorOtherChargesValue"
                                    placeholder="0.00"
                                    id="vendorOtherChargesValue"
                                    value={getOtherChargesValue.toFixed(2)}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Freight Value"
                                    name="vendorFreightValue"
                                    placeholder="0.00"
                                    id="vendorFreightValue"
                                    value={formInputs.vendorFreightValue}
                                    onChange={onInputChange}
                                    disabled={false}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Total Invoice Value "
                                    name="vendorTotalInvoiceValue "
                                    placeholder="0.00"
                                    id="vendorTotalInvoiceValue"
                                    value={(
                                      Number(subTotalValue) +
                                      Number(getOtherChargesValue) +
                                      Number(getInvTaxTotalValue) +
                                      Number(formInputs.vendorFreightValue)
                                    ).toFixed(2)}
                                    // onChange={onInputChange}
                                    disabled={true}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Upload invoice details */}
                {/*    <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">ID</span>
                        </Col>

                        <Col xs={4} md={4} lg={4}>
                          <span className="headerTitle">
                            {" "}
                            Upload Invoice details
                          </span>
                          <span className="subHeaderTitle">
                            Invoice details
                          </span>
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="headerButtonAlign"
                        >
                          <Col
                            xs={6}
                            md={6}
                            lg={6}
                            className="d-flex justify-content-end mr-2 mt-1"
                          >
                            {file && (
                              <p>
                                File: <b>{file.name}</b>{" "}
                              </p>
                            )}
                          </Col>
                          <Col xs={6} md={3} lg={3} className="">
                            {!file && (
                              <button onClick={selectFile} className="btnTable">
                                <i className="bi bi-upload mr-2"></i>
                                Select Invoice
                              </button>
                            )}
                            <input
                              type="file"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                            />

                            {file && (
                              <>
                                {!uploadStatus && (
                                  <button
                                    className="btnTable"
                                    onClick={uploadInvoice}
                                  >
                                    <i className="bi bi-upload mr-2"></i>
                                    Upload
                                  </button>
                                )}

                                {uploadStatus && (
                                  <button className="btnTable" disabled={true}>
                                    <Spinner
                                      as="span"
                                      animation="grow"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                    Loading...
                                  </button>
                                )}
                              </>
                            )}
                          </Col>
                          {file && (
                            <Col xs={6} md={1} lg={1} className="">
                              <button
                                className="btnDelete"
                                onClick={cancelInvoice}
                              >
                                <i className="bi bi-x-circle"></i>
                              </button>
                            </Col>
                          )}
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <div className="accordion-body">
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Invoice Number *"
                                    name="vendorInvoiceNo"
                                    id="vendorInvoiceNo"
                                    value={invoiceData?.invoiceNumber}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Invoice Date*"
                                    name="vendorInvoiceDate"
                                    id="vendorInvoiceDate"
                                    value={invoiceData?.invoiceDate}
                                    disabled={true}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="totalAmount"
                                    name="vendorBasicValue"
                                    placeholder="0.00"
                                    id="vendorBasicValue"
                                    value={invoiceData?.totalAmount}
                                    disabled={true}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* Invoice Bank Details */}
                {/*   <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">ID</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">
                            Invoice Bank Details
                          </span>
                          <span className="subHeaderTitle">
                            Invoice Bank Details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col>
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Select Bank A/C Number "
                              placeholder=""
                              data={getSupplierBankData}
                              id="selectedBankDetails"
                              iconClassName="dropdownIcon"
                              name="selectedBankDetails"
                              setValue={
                                formInputs?.selectedBankDetails?.name || []
                              }
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Bank Account Holder Name"
                              name="AccountHolderName"
                              placeholder=""
                              value={getDropdownData?.AccountHolderName}
                              // onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Swift Code/ IFSC Code"
                              name="swiftIfscCode"
                              placeholder=""
                              value={getDropdownData?.swiftIfscCode}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Bank Name"
                              name="bankName2"
                              placeholder=""
                              value={getDropdownData?.bankName2}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="Branch Address"
                              name="bankAddress"
                              placeholder=""
                              value={getDropdownData?.bankAddress}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="Bank Country"
                              name="bankCountry"
                              placeholder=""
                              value={getDropdownData?.bankCountry}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="Bank ID"
                              name="bankKey"
                              placeholder=""
                              value={getDropdownData?.bankKey}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="IBAN"
                              name="iban"
                              placeholder=""
                              value={getDropdownData?.iban}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/*footer create entry sheet button   */}
                <div className="pageFooter mb-3">
                  <Row className="rowDirection">
                    <Col xs={12} md={2} lg={2} className="">
                      <button
                        className="btn w-full"
                        onClick={handleSave}
                        disabled={disabled}
                      >
                        Post Invoice
                      </button>
                    </Col>
                  </Row>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>

      {/* Header Text */}
      <HeaderText
        index={0}
        headername="Add Other Charges"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="OtherChargesID"
        type="Number"
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE}
      />
    </main>
  );
};

export default CreateInvoice;
